import React, { useState, useEffect } from 'react';
import {
	Container,
	Button,
	Form,
	Row,
	Col,
	FormControl,
} from 'react-bootstrap';
import '../../../assets/css/AddNewJob.css';
import { HorizontalRuleIcon } from '@primer/octicons-react';
import { Formik, Field } from 'formik';
import * as Yup from 'yup';
import { showLoader, hideLoader } from '../../../helper/loader';
import { ReqGet, ReqPatch } from '../../../config/Requests';
import { useNavigate, useLocation } from 'react-router-dom';
import { Header, Footer } from '../../Container';
import Select from 'react-select';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

function Readonly() {
	let navigate = useNavigate();
	const { id } = useParams();

	const [loaded, setLoaded] = useState(false);
	const [data, setJob] = useState({});
	const [showChildTag, setShowChildTag] = useState(false);
	const [parentTag, setParentTag] = useState(null);
	const [childTags, setChildTags] = useState([]);
	const [initialValues, setInitialValues] = useState({});
	const [jobType, setJobType] = useState('');
	const [tools, setTools] = useState(['']);
	const [otherRequirements, setOtherRequirements] = useState(['']);
	const [expertise, setExpertise] = useState(['']);
	const [workerType, setWorkerType] = useState('');
	const validationSchema = Yup.object().shape({
		title: Yup.string()
			.required('*Title is required')
			.max(100, 'Title should not be more than 100 characters')
			.min(3, 'Title should contain at least 3 characters'),
		description: Yup.string().required('*Description is required'),
		specific_qualification: Yup.string().required(
			'*Specific Qualification is required'
		),
		start_pay_range: Yup.number()
			.positive('Must be positive number')
			.required('*This field is required'),
		end_pay_range: Yup.number()
			.positive('Must be positive number')
			.required('*This field is required')
			.min(
				Yup.ref('start_pay_range'),
				'Max Pay rate must be greater then starter'
			),

		job_type: Yup.string().required('*Job type is required'),
		job_location: Yup.string().required('*Job type is required'),
		priority: Yup.string().required('Priority Level is required'),
	});

	const [tags, setTags] = useState([]);
	const [chosenTags, setChosenTags] = useState([]);
	const [selectedTags, setSelectedTags] = useState([]);
	const [returnedTags, setReturnedTags] = useState([]);

	useEffect(() => {
		let selected = [];

		tags.map(tag => {
			tag.child_tags.map(child => {
				if (chosenTags.includes(child.id)) {
					selected = [
						...selected,
						{ label: child.display_name, value: child.id, id: child.id },
					];
				}
			});
		});

		setSelectedTags(selected);
	}, [chosenTags]);

	useEffect(() => {
		if (tags.length === 0) return;
		setReturnedTags(returnedTags);
		data?.tags && setChosenTags(data?.tags?.map(tag => tag.id));

		let tag = tags.find(tag => tag.id === data.tag_parent_id);
		setShowChildTag(true);
		setParentTag({ label: tag?.display_name, value: tag?.id });
	}, [tags, data]);

	useEffect(() => {
		showLoader();
		ReqGet('tags')
			.then(res => {
				setTags(res.data.data);
			})
			.catch(err => {
				console.log(err.message);
			});

		ReqGet(`jobs/${id}`)
			.then(({ data }) => {
				if (data.status) {
					setJob({ ...data.data });
					setInitialValues({ ...data.data });
					hideLoader();

					setOtherRequirements(data?.data?.other_requirements);
					setTools(data?.data?.tool);
					setExpertise(data?.data?.specific_expertise);
					setWorkerType(data?.data?.worker_type);
					setLoaded(true);
				}
			})
			.catch(err => {
				console.log(err.message);
			});
	}, []);

	//states and city
	const [statesData, setStatesData] = useState([]);
	const [citiesData, setCitiesData] = useState([]);

	useEffect(() => {
		//get states
		ReqGet('states')
			.then(res => {
				setStatesData(res.data);
				const state_id = data.job_state || res?.data[0]?.id;

				//call cities api
				if (state_id) {
					ReqGet('cities/' + state_id)
						.then(res => {
							console.log(statesData);
							setCitiesData(res.data);
						})
						.catch(err => {
							console.log(err.message);
						});
				}
			})
			.catch(err => {
				console.log(err.message);
			});
	}, [data]);

	const loadcities = (id, setFieldValue) => {
		ReqGet('cities/' + id)
			.then(res => {
				setCitiesData(res.data);
			})
			.catch(err => {
				console.log(err.message);
			});

		setFieldValue('job_state', id);
	};

	const formSubmit = values => {
		const params = { ...values, tags: chosenTags };
		showLoader();
		ReqPatch(`jobs/${data.id}`, params)
			.then(res => {
				if (res.status === 200) {
					navigate(`/job-post-success`);
				} else {
					toast.error(res.data.message);
				}
			})
			.catch(err => {
				console.log(err.response);
			})
			.finally(hideLoader());
	};
	const handleChangeMultiInput = (e, index, items, setItems) => {
		const { value } = e.target;
		const list = [...items];
		list[index] = value;
		setItems(list);
	};

	return (
		<Container fluid='true'>
			<Header type='member' />
			<Container className='add-new-job'>
				<Row>
					<Col>
						<div className='mt-2 mb-3 recruiter_actions' />
						<div className={'top-actions'}>
							<h4 className={'text-orange'}>Job Details</h4>
						</div>
					</Col>
				</Row>
				<Row>
					<Col>
						{loaded ? (
							<Formik
								initialValues={initialValues}
								validationSchema={validationSchema}
								onSubmit={(values, { setSubmitting, resetForm }) => {
									formSubmit(values, setSubmitting, resetForm);
								}}
							>
								{({
									errors,
									touched,
									values,
									handleChange,
									setFieldValue,
									submitForm,
								}) => (
									<Form>
										<Form.Group controlId='newJobType'>
											<Form.Label className='text-primary'>
												Job Title
											</Form.Label>
											<Form.Control
												readonly
												disabled
												value={values.title}
												name='title'
												rows='1'
												className={`${
													errors.title && touched.title ? 'error' : ''
												}`}
												as='textarea'
												placeholder='Enter title here'
											/>
											{errors.title && touched.title ? (
												<div className={`red mb-1 fs15`}>{errors.title}</div>
											) : null}
										</Form.Group>
										<Form.Group controlId='newJobGeneral'>
											<Form.Label className='text-primary'>General</Form.Label>
											<Form.Control
												readonly
												disabled
												value={values.description}
												name='description'
												as='textarea'
												rows='2'
												className={`${
													errors.description && touched.description
														? 'error'
														: ''
												}`}
												placeholder='Enter text here'
											/>
											{errors.description && touched.description ? (
												<div className={`red mb-1 fs15`}>
													{errors.description}
												</div>
											) : null}
										</Form.Group>
										<Form.Group controlId='newJobSq'>
											<Form.Label className='text-primary'>
												Specific qualifications
											</Form.Label>
											<Form.Control
												readonly
												disabled
												value={values.specific_qualification}
												name='specific_qualification'
												as='textarea'
												rows='2'
												className={`${
													errors.specific_qualification &&
													touched.specific_qualification
														? 'error'
														: ''
												}`}
												placeholder='Enter specific qualification here'
											/>
											{errors.specific_qualification &&
											touched.specific_qualification ? (
												<div className={`red mb-1 fs15`}>
													{errors.specific_qualification}
												</div>
											) : null}
										</Form.Group>
										<Form.Group controlId='newJobGeneral' disabled readonly>
											<Form.Label className='text-primary'>Tags</Form.Label>
											<div style={{ display: 'flex' }}>
												<div style={{ minWidth: '220px', width: '1000px' }}>
													<Select
														value={parentTag}
														isSearchable={false}
														readonly
														disabled
													/>
												</div>
											</div>
											<Row style={{ marginTop: '10px' }}>
												{showChildTag ? (
													<Col lg='12'>
														<Form.Label className='text-primary'>
															Child Tags
														</Form.Label>
														<div style={{ display: 'flex' }}>
															<div
																style={{ minWidth: '220px', width: '1000px' }}
															>
																<Select
																	value={selectedTags}
																	isMulti
																	isSearchable={false}
																	name='tags'
																	options={childTags}
																	className='basic-multi-select'
																	classNamePrefix='select'
																	readonly
																	disabled
																/>
															</div>
														</div>
													</Col>
												) : (
													''
												)}
											</Row>
										</Form.Group>
										<hr></hr>
										<Form.Group controlId='newJobLocation'>
											<Form.Label className='text-primary'>
												Job Location:
											</Form.Label>
											<div key={`custom-inline-checkbox`} className='ml-5 mb-3'>
												<label className='radiobox-flex'>
													<Field
														type='radio'
														className='radiobox'
														name='job_location'
														value='onsite'
														checked={initialValues.job_location === 'onsite'}
													/>
													<span> On Site </span>
												</label>

												<label className='radiobox-flex'>
													<Field
														type='radio'
														className='radiobox'
														name='job_location'
														value='remote'
														checked={initialValues.job_location === 'remote'}
													/>
													<span> Remote </span>
												</label>

												<label className='radiobox-flex'>
													<Field
														type='radio'
														className='radiobox'
														name='job_location'
														value='both'
														checked={initialValues.job_location === 'both'}
													/>
													<span> Both </span>
												</label>

												{errors.job_location && touched.job_location ? (
													<div className={`red mb-1 fs15`}>
														{errors.job_location}
													</div>
												) : null}
											</div>
										</Form.Group>

										<hr></hr>

										<Form.Group controlId='newJobMeetings'>
											<Form.Label className='text-primary'>
												On-site Meetings:
											</Form.Label>

											<div key={`custom-inline-checkbox`} className='ml-5 mb-3'>
												<label className='radiobox-flex'>
													<Field
														type={'radio'}
														className='radiobox'
														name='onsite_meetings'
														checked={initialValues.onsite_meetings === 'yes'}
														readonly
													/>
													<span> Yes </span>
												</label>

												<label className='radiobox-flex'>
													<Field
														type={'radio'}
														className='radiobox'
														name='onsite_meetings'
														checked={initialValues.onsite_meetings === 'no'}
														readonly
														value='no'
													/>
													<span> No </span>
												</label>

												{errors.onsite_meetings && touched.onsite_meetings ? (
													<div className={`red mb-1 fs15`}>
														{errors.onsite_meetings}
													</div>
												) : null}
											</div>
										</Form.Group>

										<hr></hr>

										<Form.Group controlId='newJobClearance'>
											<Form.Group controlId='newJobDestination'>
												<Form.Label className='text-orange'>
													Security Level
												</Form.Label>
												<div
													key={`custom-inline-checkbox`}
													className='ml-5 mb-3'
												>
													<label className='radiobox-flex'>
														<Field
															type='radio'
															className='radiobox'
															checked={initialValues?.security_level === '1'}
															name='security_level'
															readonly
															id='itar'
														/>
														<span> ITAR </span>
													</label>

													<label className='radiobox-flex'>
														<Field
															type='radio'
															className='radiobox'
															name='security_level'
															checked={initialValues?.security_level === '2'}
															readonly
															id='secret'
														/>
														<span> Secret </span>
													</label>

													<label className='radiobox-flex'>
														<Field
															type='radio'
															className='radiobox'
															name='security_level'
															checked={initialValues.security_level === '3'}
															readonly
															id='top-secret'
														/>
														<span> Top Secret </span>
													</label>

													{errors.security_level && touched.security_level ? (
														<div className={`red mb-1 fs15`}>
															{errors.security_level}
														</div>
													) : null}
												</div>
											</Form.Group>
										</Form.Group>

										<hr></hr>

										<Form.Group controlId='newJobRate'>
											<Form.Label className='text-primary'>
												Pay rate range
											</Form.Label>
											<Row>
												<Col xs lg={2}>
													<Form.Control
														value={values.start_pay_range}
														readonly
														disabled
														name='start_pay_range'
														type='number'
														className={`${
															errors.start_pay_range && touched.start_pay_range
																? 'error'
																: ''
														}`}
														placeholder={'From'}
													/>
													{errors.start_pay_range && touched.start_pay_range ? (
														<div className={`red mb-1 fs15`}>
															{errors.start_pay_range}
														</div>
													) : null}
												</Col>
												<Col xs='auto'>
													<HorizontalRuleIcon size={24} />
												</Col>
												<Col xs lg={2}>
													<Form.Control
														min={values.start_pay_range}
														value={values.end_pay_range}
														readonly
														disabled
														name='end_pay_range'
														type='number'
														className={`${
															errors.end_pay_range && touched.end_pay_range
																? 'error'
																: ''
														}`}
														placeholder={'To'}
													/>
													{errors.end_pay_range && touched.end_pay_range ? (
														<div className={`red mb-1 fs15`}>
															{errors.end_pay_range}
														</div>
													) : null}
												</Col>
											</Row>
										</Form.Group>

										<hr></hr>
										<Row>
											<Col>
												<Form.Group controlId='newJobDate'>
													<Form.Label className='text-primary'>Date</Form.Label>
													<Form.Group className='pl-5'>
														<>
															<Col xs='auto'>
																{' '}
																<Form.Label> Start Date </Form.Label>{' '}
															</Col>
															<Col>
																{' '}
																<FormControl
																	placeholder='Select Start Date'
																	aria-label='Username'
																	aria-describedby='basic-addon1'
																	type='date'
																	readonly
																	disabled
																	value={values.start_date}
																	name='start_date'
																	max={values.end_date}
																/>{' '}
															</Col>
															<Col xs='auto'>
																{' '}
																<Form.Label> End Date </Form.Label>{' '}
															</Col>
															<Col>
																{' '}
																<FormControl
																	placeholder='Select Start Date'
																	aria-label='Username'
																	aria-describedby='basic-addon1'
																	type='date'
																	readonly
																	disabled
																	value={values.end_date}
																	name='end_date'
																	min={values.start_date}
																/>{' '}
															</Col>
														</>
													</Form.Group>
												</Form.Group>
											</Col>
											<Col>
												<Form.Group controlId='newJobPrioLevel'>
													<Form.Label className='text-primary'>
														Priority Level
													</Form.Label>
													<Form.Control
														as='select'
														custom
														name='priority'
														readonly
														disabled
														placeholder='Select Level'
														required
														value={values.priority}
													>
														<option value='high'> High </option>
														<option value='medium'> Medium </option>
														<option value='standard'> Standard </option>
													</Form.Control>
												</Form.Group>
											</Col>
										</Row>

										<hr></hr>
										<br />
										{/* add expertise */}
										<Row className='bg-label mt-1'>
											<Col className='fw-bold p-1 ml-3'>
												{' '}
												Expertise{' '}
											</Col>
										</Row>
										<Row>
											<Col>
												<ul className='list-group list-group-flush'>
													<li className='list-group-item fw-bold'>
														{expertise?.map((item, i) => {
															return (
																<div key={i}>
																	<li className='list-group-item font-weight-normal'>
																		<Form.Group controlId='formBasicEmail'>
																			<Form.Control
																				name='first_name'
																				onChange={e =>
																					handleChangeMultiInput(
																						e,
																						i,
																						expertise,
																						setExpertise
																					)
																				}
																				type='text'
																				placeholder='Add Expertise'
																				defaultValue={item}
																				value={item}
																				readonly
																				disabled
																			/>
																		</Form.Group>
																	</li>
																</div>
															);
														})}
													</li>
													<li className='list-group-item font-weight-normal'></li>
												</ul>
											</Col>
										</Row>

										{/* end */}
										<br />
										{/* add tools */}
										<Row className='bg-label mt-1'>
											<Col className='fw-bold p-1 ml-3'> Tools </Col>
										</Row>
										<Row>
											<Col>
												<ul className='list-group list-group-flush'>
													<li className='list-group-item fw-bold'>
														{tools?.map((item, i) => {
															return (
																<div key={i}>
																	<li className='list-group-item font-weight-normal'>
																		<Form.Group controlId='formBasicEmail'>
																			<Form.Control
																				name='tools'
																				readonly
																				disabled
																				type='text'
																				placeholder='Add Tool'
																				defaultValue={item}
																				value={item}
																			/>
																		</Form.Group>
																	</li>
																</div>
															);
														})}
													</li>
													<li className='list-group-item font-weight-normal'></li>
												</ul>
											</Col>
										</Row>

										{/* end */}
										<br />
										{/* add other_requirements */}
										<Row className='bg-label mt-1'>
											<Col className='fw-bold p-1 ml-3'>
												{' '}
												Other Requirements{' '}
											</Col>
										</Row>
										<Row>
											<Col>
												<ul className='list-group list-group-flush'>
													<li className='list-group-item fw-bold'>
														{otherRequirements.map((item, i) => {
															return (
																<div key={i}>
																	<li className='list-group-item font-weight-normal'>
																		<Form.Group controlId='formBasicEmail'>
																			<Form.Control
																				name='requirement'
																				onChange={e =>
																					handleChangeMultiInput(
																						e,
																						i,
																						otherRequirements,
																						setOtherRequirements
																					)
																				}
																				type='text'
																				placeholder='Add requirement'
																				defaultValue={item}
																				value={item}
																				readonly
																				disabled
																			/>
																		</Form.Group>
																	</li>
																</div>
															);
														})}
													</li>
													<li className='list-group-item font-weight-normal'></li>
												</ul>
											</Col>
										</Row>

										{/* end */}
										<Row>
											<Col>
												<Form.Group controlId='newStates'>
													<Form.Label className='text-primary'>
														States
													</Form.Label>
													<Form.Control
														as='select'
														value={values.job_state}
														custom
														name='job_state'
														readonly
														disabled
														placeholder='Select State'
														required
													>
														<option value=''>Select State</option>
														return(
														{statesData.map((item, i) => {
															return (
																<option key={i} value={item.id}>
																	{item.name}
																</option>
															);
														})}
														)
													</Form.Control>
													{errors.job_state && touched.job_state ? (
														<div className={`red mb-1 fs15`}>
															{errors.job_state}
														</div>
													) : null}
												</Form.Group>
											</Col>
											<Col>
												<Form.Group controlId='newCities'>
													<Form.Label className='text-primary'>
														Cities
													</Form.Label>
													<Form.Control
														as='select'
														value={values.job_city}
														custom
														name='job_city'
														readonly
														disabled
														placeholder='Select city'
														required
													>
														<option value=''>Select City</option>
														return(
														{citiesData.map((item, i) => {
															return (
																<option key={i} value={item.id}>
																	{item.name}
																</option>
															);
														})}
														)
													</Form.Control>
													{errors.job_city && touched.job_city ? (
														<div className={`red mb-1 fs15`}>
															{errors.job_city}
														</div>
													) : null}
												</Form.Group>
											</Col>
										</Row>

										<hr></hr>
										<Form.Group controlId='jobType'>
											<Form.Label className='text-primary'>Job Type</Form.Label>
											<Form.Group
												controlId='newJobDestination'
												className='ml-5'
											>
												<div key={`custom-inline-checkbox`}>
													<Form.Check
														custom
														inline
														label='Full Time'
														name='jobType'
														type='radio'
														id='fullTime'
														checked={initialValues?.job_type === 'fullTime'}
														value='fullTime'
													/>
													<Form.Check
														custom
														inline
														label='Half Time'
														name='jobType'
														type='radio'
														id='halfTime'
														checked={initialValues?.job_type === 'halfTime'}
														value='halfTime'
													/>
													<Form.Check
														custom
														inline
														label='Full & half time'
														name='jobType'
														type='radio'
														id='both'
														checked={initialValues?.job_type === 'both'}
														value='both'
														onChange={() => {
															setJobType('both');
														}}
													/>
												</div>
											</Form.Group>
										</Form.Group>
										<hr />
										<Form.Group controlId='newJobClearance'>
											<Form.Label className='text-primary'>
												Worker Type
											</Form.Label>
											<Form.Group
												controlId='newJobDestination'
												className='ml-5'
											>
												<div key={`custom-inline-checkbox`}>
													<Form.Check
														custom
														inline
														name='job_type'
														checked={workerType === '1099-subcontractor'}
														label='1099 Subcontractor'
														value='1099-subcontractor'
														type={`radio`}
														id={`job-type-1099-subcontractor`}
													/>
													<Form.Check
														custom
														inline
														name='job_type'
														checked={workerType === 'w2-contingent-worker'}
														value='w2-contingent-worker'
														label='W2 Contingent Worker'
														type={`radio`}
														id={`job-type-w2-contingent-worker`}
													/>
													<Form.Check
														custom
														inline
														name='job_type'
														checked={
															workerType === 'contingent-to-full-time-employee'
														}
														value='contingent-to-full-time-employee'
														label='Contingent to Full Time Employee'
														type={`radio`}
														id={`job-type-contingent-to-full-time-employee`}
													/>
													<Form.Check
														custom
														inline
														name='job_type'
														checked={workerType === 'part-time-contingent'}
														value='part-time-contingent'
														label='Part Time Contingent'
														type={`radio`}
														id={`job-type-part-time-contingent`}
													/>
												</div>
											</Form.Group>
										</Form.Group>
									</Form>
								)}
							</Formik>
						) : (
							''
						)}
					</Col>
				</Row>
				<div style={{ height: '142px' }} />
			</Container>
			<Footer />
		</Container>
	);
}

export default Readonly;
